import { render, staticRenderFns } from "./CardParty.vue?vue&type=template&id=d4902f1a"
import script from "./CardParty.vue?vue&type=script&lang=ts"
export * from "./CardParty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports